import { render, staticRenderFns } from "./TerrificPagination.vue?vue&type=template&id=34b11f64&scoped=true"
import script from "./TerrificPagination.vue?vue&type=script&lang=js"
export * from "./TerrificPagination.vue?vue&type=script&lang=js"
import style0 from "./TerrificPagination.vue?vue&type=style&index=0&id=34b11f64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b11f64",
  null
  
)

export default component.exports